import { initializeStore } from './initialize-store';
import { TStore } from './store-types';

/**
 * Wrapper for the application new Redux store.
 * DO NOT USE IT UNLESS YOU HAVE TO SUPPORT ACTION DISPATCH
 * OR READING STATE FROM FLUXIBLE LEGACY CODE!
 * Otherwise, use the normal redux API.
 */

let store: TStore;

export function init() {
  store = initializeStore();
  return store;
}

export function dispatch(action) {
  return store?.dispatch(action);
}

export function getState() {
  return store?.getState();
}
